import Result from '../../common/result';
import { TokenResult } from '../../services/common/token';
import BaseToken from './BaseToken';

/** Result callback for performing a token renewal */
export type TokenRenewalResult = (tokenResult: TokenResult) => void;
/** Callback function to request a token renewal. Waits for result callback */
export type RequestTokenRenewal = (resultCallback: TokenRenewalResult) => void;

export default class RenewableToken extends BaseToken {
  private requestTokenRenewalCallback: RequestTokenRenewal;

  constructor(token: string, requestTokenRenewalCallback: RequestTokenRenewal) {
    super(token);
    this.requestTokenRenewalCallback = requestTokenRenewalCallback;
  }

  async getToken(): Promise<TokenResult> {
    if (this.isTokenValid()) {
      return Result.successful(this.token);
    }

    return this.renewToken();
  }

  private async renewToken(): Promise<TokenResult> {
    return new Promise<TokenResult>((resolve) => {
      this.requestTokenRenewalCallback((tokenResult) => {
        if (tokenResult.isSuccessful()) {
          this.setToken(tokenResult.success());
        }

        resolve(tokenResult);
      });
    });
  }
}
